// extracted by mini-css-extract-plugin
module.exports = {"map":"bx_jw","map_isAdaptive":"bx_jx"};